// NPC Data - All NPC configurations for TypeTown
// Each NPC has name, colors, greeting, questions, and facts for quizzes

export const NPC_DATA = {
  farmer: {
    name: 'Fred the Farmer',
    color: '#4CAF50',
    eyeColor: '#8BC34A',
    greeting: 'Howdy! Welcome to my farm!',
    questions: [
      { q: "What's your name?", a: "I'm Fred the Farmer! I grow vegetables and take care of animals." },
      { q: "How are you today?", a: "I'm great! The sun is shining and my crops are growing well." },
      { q: "What do you grow?", a: "I grow carrots, tomatoes, lettuce, and the sweetest strawberries!" },
      { q: "What is your favourite animal?", a: "I love my pig called Daisy! She's very friendly." },
      { q: "What time do you wake up?", a: "I wake up at 5 o'clock every morning to feed the chickens!" },
      { q: "Can you tell me a joke?", a: "Why did the scarecrow win an award? He was outstanding in his field!" },
    ],
    facts: {
      1: { question: "What is Fred's favourite animal?", answer: "daisy", hint: "It's a pig!" },
      2: { question: "What time does Fred wake up every morning?", answer: "5", hint: "It's very early!" },
      3: { question: "What fruit does Fred say is the sweetest?", answer: "strawberries", hint: "They're red and small." },
      4: { question: "What does Fred grow that is orange?", answer: "carrots", hint: "Rabbits love them!" },
      5: { question: "Why did the scarecrow win an award?", answer: "outstanding", hint: "He was ____ in his field." },
    }
  },
  baker: {
    name: 'Betty the Baker',
    color: '#E8D5B7',
    eyeColor: '#FF9800',
    greeting: 'Hello sweetie! Something smells delicious!',
    questions: [
      { q: "What's your name?", a: "I'm Betty the Baker! I bake bread, cakes, and biscuits all day long." },
      { q: "How are you today?", a: "Wonderful! I just baked 50 cupcakes for the village party!" },
      { q: "What do you bake?", a: "Bread, croissants, muffins, and my famous chocolate chip biscuits!" },
      { q: "What is your favourite thing to bake?", a: "Birthday cakes! I love making people smile on their special day." },
      { q: "What time does your bakery open?", a: "I open at 6 o'clock in the morning, bright and early!" },
      { q: "Can you tell me a joke?", a: "Why did the biscuit go to the doctor? It was feeling crumby!" },
    ],
    facts: {
      1: { question: "What is Betty's favourite thing to bake?", answer: "birthday cakes", hint: "For special days!" },
      2: { question: "What time does Betty's bakery open?", answer: "6", hint: "Early morning!" },
      3: { question: "How many cupcakes did Betty bake for the party?", answer: "50", hint: "It's half of 100." },
      4: { question: "What kind of biscuits is Betty famous for?", answer: "chocolate chip", hint: "They have bits of chocolate." },
      5: { question: "Why did the biscuit go to the doctor?", answer: "crumby", hint: "It was feeling ____." },
    }
  },
  teacher: {
    name: 'Tom the Teacher',
    color: '#5C6BC0',
    eyeColor: '#3F51B5',
    greeting: 'Hello there, young learner!',
    questions: [
      { q: "What's your name?", a: "I'm Tom the Teacher! I help children learn to read and write." },
      { q: "How are you today?", a: "Fantastic! My students learned 10 new words today!" },
      { q: "What do you teach?", a: "I teach reading, writing, maths, and lots of fun science experiments!" },
      { q: "What is your favourite subject?", a: "Reading! Books can take you on amazing adventures." },
      { q: "How many students do you have?", a: "I have 25 wonderful students in my class." },
      { q: "Can you tell me a joke?", a: "Why was the maths book sad? It had too many problems!" },
    ],
    facts: {
      1: { question: "What is Tom's favourite subject?", answer: "reading", hint: "It involves books!" },
      2: { question: "How many students does Tom have?", answer: "25", hint: "That's 5 times 5!" },
      3: { question: "How many new words did Tom's students learn?", answer: "10", hint: "It's the same as two hands of fingers." },
      4: { question: "What does Tom say books can take you on?", answer: "adventures", hint: "Exciting journeys!" },
      5: { question: "Why was the maths book sad?", answer: "problems", hint: "It had too many ____." },
    }
  },
  doctor: {
    name: 'Dr. Diana',
    color: '#E0E0E0',
    eyeColor: '#00BCD4',
    greeting: 'Hello! I hope you\'re feeling well today!',
    questions: [
      { q: "What's your name?", a: "I'm Dr. Diana! I help people feel better when they're sick." },
      { q: "How are you today?", a: "Very well! I've helped 12 patients today already." },
      { q: "What do you do?", a: "I'm a doctor! I check people's health and give them medicine." },
      { q: "What should we eat to stay healthy?", a: "Fruits, vegetables, and drink lots of water! Also get plenty of sleep." },
      { q: "How many hours of sleep do children need?", a: "Children need about 10 hours of sleep every night!" },
      { q: "Can you tell me a joke?", a: "Why did the doctor carry a red pen? In case they needed to draw blood!" },
    ],
    facts: {
      1: { question: "How many patients did Dr. Diana help today?", answer: "12", hint: "It's the same as a dozen." },
      2: { question: "How many hours of sleep do children need?", answer: "10", hint: "Same as the number of fingers!" },
      3: { question: "What does Dr. Diana say we should drink lots of?", answer: "water", hint: "It's clear and wet." },
      4: { question: "What colour pen does Dr. Diana carry?", answer: "red", hint: "The colour of blood." },
      5: { question: "What does Dr. Diana give to sick people?", answer: "medicine", hint: "It helps you feel better." },
    }
  },
  artist: {
    name: 'Arty the Artist',
    color: '#FF6B6B',
    eyeColor: '#8B5CF6',
    greeting: 'Welcome to my studio! Let\'s create!',
    questions: [
      { q: "What's your name?", a: "I'm Arty the Artist! I paint pictures and make sculptures." },
      { q: "How are you today?", a: "Inspired! I'm working on a painting of a beautiful sunset." },
      { q: "What do you like to paint?", a: "I love painting nature - trees, flowers, mountains, and the ocean!" },
      { q: "What is your favourite colour?", a: "Purple! It's the colour of creativity and imagination." },
      { q: "How many paintings have you made?", a: "I've made over 200 paintings in my lifetime!" },
      { q: "Can you tell me a joke?", a: "Why did the artist go to jail? Because they got framed!" },
    ],
    facts: {
      1: { question: "What is Arty's favourite colour?", answer: "purple", hint: "It's a mix of red and blue." },
      2: { question: "How many paintings has Arty made?", answer: "200", hint: "That's 2 hundred!" },
      3: { question: "What is Arty painting right now?", answer: "sunset", hint: "It happens when the sun goes down." },
      4: { question: "Why did the artist go to jail?", answer: "framed", hint: "They got ____!" },
      5: { question: "What type of things does Arty like to paint?", answer: "nature", hint: "Trees, flowers, mountains..." },
    }
  },
  explorer: {
    name: 'Rex the Explorer',
    color: '#795548',
    eyeColor: '#4CAF50',
    greeting: 'Greetings, fellow adventurer!',
    questions: [
      { q: "What's your name?", a: "I'm Rex the Explorer! I travel the world discovering new places." },
      { q: "How are you today?", a: "Excited! I found an ancient ruin yesterday." },
      { q: "Where have you been?", a: "I've explored jungles, mountains, oceans, and even volcanoes!" },
      { q: "What is your favourite discovery?", a: "An ancient map that showed secret treasure locations!" },
      { q: "How many countries have you visited?", a: "I've visited 47 different countries around the world!" },
      { q: "Can you tell me a joke?", a: "Why did the explorer get lost? They forgot their compass!" },
    ],
    facts: {
      1: { question: "What did Rex find yesterday?", answer: "ancient ruin", hint: "It's very old!" },
      2: { question: "How many countries has Rex visited?", answer: "47", hint: "It's almost 50!" },
      3: { question: "What is Rex's favourite discovery?", answer: "ancient map", hint: "It shows treasure locations." },
      4: { question: "Why did the explorer get lost?", answer: "compass", hint: "They forgot their ____." },
      5: { question: "What hot place has Rex explored?", answer: "volcanoes", hint: "Mountains that explode!" },
    }
  },
  chef: {
    name: 'Chef Charlie',
    color: '#FF9800',
    eyeColor: '#4CAF50',
    greeting: 'Something delicious is cooking!',
    questions: [
      { q: "What's your name?", a: "I'm Chef Charlie! Master of pots, pans, and perfect pasta." },
      { q: "How are you today?", a: "Hot and ready to cook! I know 500 different recipes!" },
      { q: "What can you cook?", a: "Pizza, pasta, soup, salads, and the world's best chocolate cake!" },
      { q: "What is your favourite dish?", a: "Spaghetti with tomato sauce! Simple but delicious." },
      { q: "What is your secret ingredient?", a: "Love! And a tiny bit of butter." },
      { q: "Can you tell me a joke?", a: "Why did the chef win the cooking show? They had the best taste!" },
    ],
    facts: {
      1: { question: "What is Chef Charlie's favourite dish?", answer: "spaghetti", hint: "It's long pasta!" },
      2: { question: "How many recipes does Chef Charlie know?", answer: "500", hint: "That's half a thousand!" },
      3: { question: "What is Chef Charlie's secret ingredient?", answer: "love", hint: "It comes from the heart." },
      4: { question: "What cake is Chef Charlie famous for?", answer: "chocolate", hint: "It's brown and sweet." },
      5: { question: "Why did the chef win the cooking show?", answer: "taste", hint: "They had the best ____." },
    }
  },
  musician: {
    name: 'Melody the Musician',
    color: '#E91E63',
    eyeColor: '#3F51B5',
    greeting: 'La la la! Music fills the air!',
    questions: [
      { q: "What's your name?", a: "I'm Melody the Musician! I make beautiful music all day long. La la la!" },
      { q: "How are you today?", a: "In perfect harmony! I wrote a new song about friendship." },
      { q: "What instruments do you play?", a: "Piano, guitar, drums, violin, and I love singing!" },
      { q: "What is your favourite song?", a: "The Happy Dance! It makes everyone want to move and groove!" },
      { q: "How many songs have you written?", a: "I've written 100 songs so far, and more every day!" },
      { q: "Can you tell me a joke?", a: "What's a musician's favourite food? Tune-a fish!" },
    ],
    facts: {
      1: { question: "What is Melody's favourite song?", answer: "happy dance", hint: "It makes people move!" },
      2: { question: "How many songs has Melody written?", answer: "100", hint: "That's a century of songs!" },
      3: { question: "What did Melody write a song about?", answer: "friendship", hint: "It's about being friends." },
      4: { question: "What's a musician's favourite food?", answer: "tuna", hint: "Tune-a fish!" },
      5: { question: "What does Melody say fills the air?", answer: "music", hint: "La la la!" },
    }
  },
  librarian: {
    name: 'Lisa the Librarian',
    color: '#607D8B',
    eyeColor: '#5C6BC0',
    greeting: 'Shh! Welcome to the library!',
    questions: [
      { q: "What's your name?", a: "I'm Lisa the Librarian! I help people find the perfect book." },
      { q: "How many books are here?", a: "We have over 10,000 books in this library!" },
      { q: "What is your favourite book?", a: "I love adventure stories about brave heroes!" },
      { q: "Do you read every day?", a: "Yes! I read at least 2 books every week. That's over 100 a year!" },
      { q: "What is the oldest book here?", a: "We have a fairy tale book that is 150 years old!" },
      { q: "Can you tell me a joke?", a: "Why did the book go to the doctor? Because it lost its spine!" },
    ],
    facts: {
      1: { question: "How many books are in Lisa's library?", answer: "10000", hint: "That's ten thousand!" },
      2: { question: "What type of stories does Lisa love?", answer: "adventure", hint: "About brave heroes!" },
      3: { question: "How many books does Lisa read each week?", answer: "2", hint: "A pair of books!" },
      4: { question: "How old is Lisa's oldest book?", answer: "150", hint: "One hundred and fifty years!" },
      5: { question: "Why did the book go to the doctor?", answer: "spine", hint: "It lost its ____." },
    }
  },
  gardener: {
    name: 'Gary the Gardener',
    color: '#4CAF50',
    eyeColor: '#8BC34A',
    greeting: 'Hello! Come see my flowers!',
    questions: [
      { q: "What's your name?", a: "I'm Gary the Gardener! I grow the most beautiful flowers." },
      { q: "What do you grow?", a: "Roses, tulips, sunflowers, and daffodils!" },
      { q: "What is your favourite flower?", a: "Sunflowers! They always face the sun." },
      { q: "How big is your garden?", a: "My garden is huge! It has over 500 different plants." },
      { q: "What do plants need to grow?", a: "Sunlight, water, and good soil. And a little bit of love!" },
      { q: "Can you tell me a joke?", a: "What did the big flower say to the little flower? Hey there, bud!" },
    ],
    facts: {
      1: { question: "What is Gary's favourite flower?", answer: "sunflowers", hint: "They face the sun!" },
      2: { question: "What yellow spring flower does Gary grow?", answer: "daffodils", hint: "Yellow and trumpet-shaped!" },
      3: { question: "How many different plants are in Gary's garden?", answer: "500", hint: "Half a thousand!" },
      4: { question: "What did the big flower say to the little flower?", answer: "bud", hint: "Hey there, ____!" },
      5: { question: "What three things do plants need to grow?", answer: "sunlight", hint: "One of them comes from the sky!" },
    }
  },
  scientist: {
    name: 'Sam the Scientist',
    color: '#9C27B0',
    eyeColor: '#00BCD4',
    greeting: 'Fascinating! Another curious mind!',
    questions: [
      { q: "What's your name?", a: "I'm Sam the Scientist! I discover how the world works." },
      { q: "What do you study?", a: "I study space, animals, plants, and amazing chemistry!" },
      { q: "What is your latest discovery?", a: "I found a new type of butterfly with rainbow wings!" },
      { q: "What is your favourite experiment?", a: "Making a volcano erupt with baking soda and vinegar!" },
      { q: "How many experiments have you done?", a: "Over 1,000 experiments! Some made big messes." },
      { q: "Can you tell me a joke?", a: "Why can you never trust atoms? Because they make up everything!" },
    ],
    facts: {
      1: { question: "What did Sam discover recently?", answer: "butterfly", hint: "It has rainbow wings!" },
      2: { question: "What does Sam study that's very far away?", answer: "space", hint: "Where stars live!" },
      3: { question: "What makes Sam's volcano erupt?", answer: "baking soda", hint: "You use it in cakes too!" },
      4: { question: "How many experiments has Sam done?", answer: "1000", hint: "A thousand!" },
      5: { question: "Why can you never trust atoms?", answer: "everything", hint: "They make up ____!" },
    }
  },
  pilot: {
    name: 'Captain Pete',
    color: '#2196F3',
    eyeColor: '#1976D2',
    greeting: 'Ready for take-off?',
    questions: [
      { q: "What's your name?", a: "I'm Captain Pete! I fly aeroplanes around the world." },
      { q: "Where have you flown?", a: "Paris, New York, Tokyo, Sydney, and 50 more cities!" },
      { q: "How high do you fly?", a: "We fly at 35,000 feet - that's above the clouds!" },
      { q: "What is the longest flight?", a: "My longest flight was 18 hours from London to Australia!" },
      { q: "Were you ever scared?", a: "Once we flew through a big storm, but my training kept us safe." },
      { q: "Can you tell me a joke?", a: "Why do pilots make great friends? They always help you take off!" },
    ],
    facts: {
      1: { question: "How many cities has Captain Pete flown to besides the main ones?", answer: "50", hint: "Half of 100!" },
      2: { question: "How high does Captain Pete fly?", answer: "35000", hint: "Above the clouds!" },
      3: { question: "How many hours was Pete's longest flight?", answer: "18", hint: "Almost a whole day!" },
      4: { question: "Where did Pete's longest flight go?", answer: "australia", hint: "Land of kangaroos!" },
      5: { question: "What kept Pete safe in the storm?", answer: "training", hint: "Learning and practice!" },
    }
  },
  firefighter: {
    name: 'Fiona the Firefighter',
    color: '#F44336',
    eyeColor: '#FF9800',
    greeting: 'Stay safe, little one!',
    questions: [
      { q: "What's your name?", a: "I'm Fiona the Firefighter! I rescue people and put out fires." },
      { q: "What do you drive?", a: "A big red fire engine with loud sirens!" },
      { q: "How do you stay safe from fire?", a: "I wear a special fireproof suit and helmet!" },
      { q: "How many fires have you put out?", a: "I've put out over 300 fires in my career!" },
      { q: "What should you do in a fire?", a: "Get out, stay out, and call 999! Never hide under a bed." },
      { q: "Can you tell me a joke?", a: "What did the firefighter name their twin sons? Jose and Hose B!" },
    ],
    facts: {
      1: { question: "What colour is Fiona's fire engine?", answer: "red", hint: "The colour of strawberries!" },
      2: { question: "What type of suit does Fiona wear?", answer: "fireproof", hint: "It protects from flames!" },
      3: { question: "How many fires has Fiona put out?", answer: "300", hint: "Three hundred!" },
      4: { question: "What number should you call in a fire?", answer: "999", hint: "Three nines!" },
      5: { question: "Where should you never hide in a fire?", answer: "bed", hint: "Under the ____." },
    }
  },
  vet: {
    name: 'Victor the Vet',
    color: '#00BCD4',
    eyeColor: '#4CAF50',
    greeting: 'Hello! Do you have a pet?',
    questions: [
      { q: "What's your name?", a: "I'm Victor the Vet! I help sick animals get better." },
      { q: "What animals do you help?", a: "Dogs, cats, rabbits, hamsters, and even parrots!" },
      { q: "What is the most unusual animal you've helped?", a: "A giant tortoise that was 100 years old!" },
      { q: "Do you have your own pet?", a: "Yes! I have a golden retriever called Biscuit. She's so fluffy!" },
      { q: "What is the funniest thing a pet has done?", a: "A cat once stole my sandwich right off the table!" },
      { q: "Can you tell me a joke?", a: "What do you call a sleeping dinosaur? A dino-snore!" },
    ],
    facts: {
      1: { question: "How old was the tortoise Victor helped?", answer: "100", hint: "A whole century!" },
      2: { question: "What colourful bird has Victor helped?", answer: "parrots", hint: "They can talk!" },
      3: { question: "What is Victor's dog called?", answer: "biscuit", hint: "Something you eat with tea!" },
      4: { question: "What animal stole Victor's sandwich?", answer: "cat", hint: "It goes meow!" },
      5: { question: "What do you call a sleeping dinosaur?", answer: "dino-snore", hint: "Dino + the sound of sleeping!" },
    }
  },
  postie: {
    name: 'Pat the Postie',
    color: '#F44336',
    eyeColor: '#1976D2',
    greeting: 'Special delivery!',
    questions: [
      { q: "What's your name?", a: "I'm Pat the Postie! I deliver letters and parcels to everyone." },
      { q: "How many letters do you deliver?", a: "About 200 letters every single day!" },
      { q: "What is the best part of your job?", a: "Making people smile when they get a birthday card!" },
      { q: "Have you ever lost a letter?", a: "Never! Every letter is precious. I once delivered one in a snowstorm!" },
      { q: "What is the biggest parcel you've delivered?", a: "A giant teddy bear that was taller than me!" },
      { q: "Can you tell me a joke?", a: "Why did the letter go to school? To improve its address!" },
    ],
    facts: {
      1: { question: "How many letters does Pat deliver each day?", answer: "200", hint: "Two hundred!" },
      2: { question: "What makes people smile when Pat delivers it?", answer: "birthday card", hint: "You get them on your special day!" },
      3: { question: "What weather did Pat deliver in?", answer: "snowstorm", hint: "Cold and white!" },
      4: { question: "What big toy did Pat deliver?", answer: "teddy bear", hint: "A cuddly toy!" },
      5: { question: "Why did the letter go to school?", answer: "address", hint: "To improve its ____!" },
    }
  },
  police: {
    name: 'Officer Ollie',
    color: '#3F51B5',
    eyeColor: '#1976D2',
    greeting: 'Hello there, citizen!',
    questions: [
      { q: "What's your name?", a: "I'm Officer Ollie! I keep everyone safe and help those in need." },
      { q: "What do you do?", a: "I catch the bad guys and help lost children find their parents!" },
      { q: "What is your police dog called?", a: "My police dog is called Max. He's very clever!" },
      { q: "What is the bravest thing you've done?", a: "I once rescued a kitten from a very tall tree in the park!" },
      { q: "Do you like being a police officer?", a: "I love it! Helping people is the best feeling in the world." },
      { q: "Can you tell me a joke?", a: "Why did the police officer go to the cricket match? They heard someone was caught out!" },
    ],
    facts: {
      1: { question: "What is Officer Ollie's police dog called?", answer: "max", hint: "A short name!" },
      2: { question: "Who does Ollie help find their parents?", answer: "lost children", hint: "Kids who can't find their way!" },
      3: { question: "What animal did Ollie rescue from a tree?", answer: "kitten", hint: "A baby cat!" },
      4: { question: "What happened to someone at the cricket match?", answer: "caught out", hint: "They were ____ ____!" },
      5: { question: "What does Ollie say is the best feeling?", answer: "helping people", hint: "Being kind to others!" },
    }
  },
  builder: {
    name: 'Bob the Builder',
    color: '#FF9800',
    eyeColor: '#795548',
    greeting: 'Can we build it? Yes we can!',
    questions: [
      { q: "What's your name?", a: "I'm Bob the Builder! I build houses, schools, and playgrounds." },
      { q: "What tools do you use?", a: "Hammers, screwdrivers, drills, and my trusty spirit level!" },
      { q: "What is the biggest thing you've built?", a: "A 50-floor skyscraper in the city!" },
      { q: "How long did the skyscraper take?", a: "It took 3 whole years and 200 workers!" },
      { q: "What do you like building most?", a: "Playgrounds! I love seeing children having fun on my slides and swings." },
      { q: "Can you tell me a joke?", a: "Why was the builder always calm? They had everything under construction!" },
    ],
    facts: {
      1: { question: "How many floors was Bob's biggest building?", answer: "50", hint: "Half of 100!" },
      2: { question: "What does Bob use to check things are straight?", answer: "spirit level", hint: "It has a bubble!" },
      3: { question: "How many years did the skyscraper take?", answer: "3", hint: "A small number!" },
      4: { question: "What does Bob love building most?", answer: "playgrounds", hint: "Where kids play!" },
      5: { question: "How many workers built the skyscraper?", answer: "200", hint: "Two hundred!" },
    }
  },
  dancer: {
    name: 'Daisy the Dancer',
    color: '#E91E63',
    eyeColor: '#9C27B0',
    greeting: 'Let\'s dance!',
    questions: [
      { q: "What's your name?", a: "I'm Daisy the Dancer! I love ballet, tap, and hip-hop!" },
      { q: "How long have you been dancing?", a: "I've been dancing since I was 3 years old!" },
      { q: "What is your favourite dance?", a: "The Swan Lake ballet - it's so graceful and beautiful!" },
      { q: "How many shows have you performed?", a: "I've performed in over 150 shows on stage!" },
      { q: "What is the hardest move?", a: "A triple pirouette - that's spinning around 3 times on one foot!" },
      { q: "Can you tell me a joke?", a: "What do you call a dancing lamb? A baa-llerina!" },
    ],
    facts: {
      1: { question: "How old was Daisy when she started dancing?", answer: "3", hint: "Very young!" },
      2: { question: "What ballet is Daisy's favourite?", answer: "swan lake", hint: "It's about beautiful birds!" },
      3: { question: "How many shows has Daisy performed in?", answer: "150", hint: "One hundred and fifty!" },
      4: { question: "How many times do you spin in a triple pirouette?", answer: "3", hint: "The word triple gives it away!" },
      5: { question: "What do you call a dancing lamb?", answer: "baa-llerina", hint: "Like a ballerina but woolly!" },
    }
  },
  athlete: {
    name: 'Andy the Athlete',
    color: '#4CAF50',
    eyeColor: '#2196F3',
    greeting: 'Ready to run?',
    questions: [
      { q: "What's your name?", a: "I'm Andy the Athlete! I run, jump, and throw things really far!" },
      { q: "What sports do you play?", a: "Football, tennis, swimming, and I love running marathons!" },
      { q: "How fast can you run?", a: "I can run 100 metres in just 12 seconds!" },
      { q: "Have you won any medals?", a: "Yes! I've won 15 gold medals and 8 silver ones!" },
      { q: "What do you eat to stay strong?", a: "Lots of pasta, bananas, chicken, and I drink loads of water!" },
      { q: "Can you tell me a joke?", a: "Why is Cinderella bad at football? She always runs away from the ball!" },
    ],
    facts: {
      1: { question: "How many seconds does Andy take to run 100 metres?", answer: "12", hint: "A dozen!" },
      2: { question: "What long race does Andy love to run?", answer: "marathons", hint: "They're 26 miles long!" },
      3: { question: "How many gold medals has Andy won?", answer: "15", hint: "Fifteen!" },
      4: { question: "What fruit does Andy eat to stay strong?", answer: "bananas", hint: "Yellow and curved!" },
      5: { question: "Why is Cinderella bad at football?", answer: "ball", hint: "She runs away from the ____!" },
    }
  },
  astronaut: {
    name: 'Astro Alex',
    color: '#ECEFF1',
    eyeColor: '#3F51B5',
    greeting: 'Greetings from space!',
    questions: [
      { q: "What's your name?", a: "I'm Astro Alex! I travel to space in a rocket ship!" },
      { q: "Have you been to the moon?", a: "Yes! I walked on the moon and collected moon rocks!" },
      { q: "What is space like?", a: "It's dark, silent, and you float around because there's no gravity!" },
      { q: "How long were you in space?", a: "My longest trip was 6 months on the space station!" },
      { q: "Can you see Earth from space?", a: "Yes! Earth looks like a beautiful blue marble floating in darkness." },
      { q: "Can you tell me a joke?", a: "How do you organise a space party? You planet!" },
    ],
    facts: {
      1: { question: "What did Alex collect on the moon?", answer: "moon rocks", hint: "Stones from space!" },
      2: { question: "Why do you float in space?", answer: "no gravity", hint: "Nothing pulls you down!" },
      3: { question: "How many months was Alex's longest trip?", answer: "6", hint: "Half a year!" },
      4: { question: "What colour does Earth look from space?", answer: "blue", hint: "Like the ocean!" },
      5: { question: "How do you organise a space party?", answer: "planet", hint: "You ____ it!" },
    }
  },
  zookeeper: {
    name: 'Zara the Zookeeper',
    color: '#8BC34A',
    eyeColor: '#795548',
    greeting: 'Welcome to the zoo!',
    questions: [
      { q: "What's your name?", a: "I'm Zara the Zookeeper! I look after all the zoo animals." },
      { q: "What animals do you look after?", a: "Lions, elephants, penguins, monkeys, and giraffes!" },
      { q: "What is your favourite animal?", a: "The baby elephant! She's so playful and loves water." },
      { q: "How many animals are in the zoo?", a: "We have 250 animals from all around the world!" },
      { q: "What do the monkeys eat?", a: "Bananas, apples, nuts, and sometimes special monkey biscuits!" },
      { q: "Can you tell me a joke?", a: "What do you call a lazy kangaroo? A pouch potato!" },
    ],
    facts: {
      1: { question: "What is Zara's favourite animal?", answer: "baby elephant", hint: "It's big and grey and small!" },
      2: { question: "What black and white bird does Zara look after?", answer: "penguins", hint: "They waddle!" },
      3: { question: "How many animals are in Zara's zoo?", answer: "250", hint: "Two hundred and fifty!" },
      4: { question: "What yellow fruit do Zara's monkeys eat?", answer: "bananas", hint: "Monkeys love them!" },
      5: { question: "What do you call a lazy kangaroo?", answer: "pouch potato", hint: "Like a couch potato but with a pouch!" },
    }
  },
  magician: {
    name: 'Max the Magician',
    color: '#9C27B0',
    eyeColor: '#FFEB3B',
    greeting: 'Abracadabra!',
    questions: [
      { q: "What's your name?", a: "I'm Max the Magician! I perform amazing magic tricks!" },
      { q: "What can you do?", a: "I can make rabbits appear, cards fly, and people disappear!" },
      { q: "What is your favourite trick?", a: "Pulling a rabbit out of my magic hat! Hop hop!" },
      { q: "How did you learn magic?", a: "My grandmother taught me my first trick when I was 5 years old!" },
      { q: "What is your most amazing trick?", a: "I once made an entire elephant vanish on stage! Well, almost." },
      { q: "Can you tell me a joke?", a: "Why did the magician fail his exam? He could only do trick questions!" },
    ],
    facts: {
      1: { question: "What animal does Max pull from his hat?", answer: "rabbit", hint: "It hops!" },
      2: { question: "What magic word does Max say?", answer: "abracadabra", hint: "A very long magic word!" },
      3: { question: "How old was Max when he learned his first trick?", answer: "5", hint: "The fingers on one hand!" },
      4: { question: "Who taught Max his first trick?", answer: "grandmother", hint: "A family member, very wise!" },
      5: { question: "Why did the magician fail his exam?", answer: "trick questions", hint: "____ questions!" },
    }
  },
};

// NPC visual styles for rendering characters
export const NPC_STYLES = {
  farmer: { 
    skinTone: '#8D5524', hairColor: '#8B4513', shirtColor: '#4CAF50', 
    pantsColor: '#5D4037', name: 'FRED', hairStyle: 'short', accessory: 'hat'
  },
  baker: { 
    skinTone: '#3D2314', hairColor: '#FF69B4', shirtColor: '#FFFFFF', 
    pantsColor: '#2196F3', name: 'BETTY', hairStyle: 'braids', accessory: 'headband'
  },
  teacher: { 
    skinTone: '#5C3A21', hairColor: '#00CED1', shirtColor: '#5C6BC0', 
    pantsColor: '#37474F', name: 'TOM', hairStyle: 'afro', accessory: 'glasses'
  },
  doctor: { 
    skinTone: '#3D2314', hairColor: '#E8D5A3', shirtColor: '#FFFFFF', 
    pantsColor: '#607D8B', name: 'DOC', hairStyle: 'bun', accessory: 'glasses'
  },
  artist: { 
    skinTone: '#8D5524', hairColor: '#8B5CF6', shirtColor: '#FF6B6B', 
    pantsColor: '#1a1a1a', name: 'ARTY', hairStyle: 'wavy', accessory: 'earrings'
  },
  explorer: { 
    skinTone: '#5C3A21', hairColor: '#A52A2A', shirtColor: '#FFC107', 
    pantsColor: '#4E342E', name: 'REX', hairStyle: 'braids', accessory: 'hat'
  },
  chef: { 
    skinTone: '#D4A574', hairColor: '#4169E1', shirtColor: '#FFFFFF', 
    pantsColor: '#1a1a1a', name: 'CHEF', hairStyle: 'bob', accessory: 'none'
  },
  musician: { 
    skinTone: '#3D2314', hairColor: '#FF69B4', shirtColor: '#E91E63', 
    pantsColor: '#3F51B5', name: 'MELODY', hairStyle: 'long', accessory: 'headphones'
  },
  librarian: { 
    skinTone: '#5C3A21', hairColor: '#B87333', shirtColor: '#9C27B0', 
    pantsColor: '#1a1a1a', name: 'LISA', hairStyle: 'braids', accessory: 'glasses'
  },
  gardener: { 
    skinTone: '#8D5524', hairColor: '#22C55E', shirtColor: '#4CAF50', 
    pantsColor: '#5D4037', name: 'GARY', hairStyle: 'curly', accessory: 'hat'
  },
  police: { 
    skinTone: '#3D2314', hairColor: '#1a1a1a', shirtColor: '#1565C0', 
    pantsColor: '#0D47A1', name: 'OLLIE', hairStyle: 'short', accessory: 'none'
  },
  builder: { 
    skinTone: '#C68642', hairColor: '#EF4444', shirtColor: '#FF9800', 
    pantsColor: '#5D4037', name: 'BOB', hairStyle: 'mohawk', accessory: 'hat'
  },
  dancer: { 
    skinTone: '#5C3A21', hairColor: '#00CED1', shirtColor: '#E91E63', 
    pantsColor: '#9C27B0', name: 'DAISY', hairStyle: 'pigtails', accessory: 'bow'
  },
  athlete: { 
    skinTone: '#3D2314', hairColor: '#FFD700', shirtColor: '#F44336', 
    pantsColor: '#212121', name: 'ANDY', hairStyle: 'afro', accessory: 'headband'
  },
  astronaut: { 
    skinTone: '#8D5524', hairColor: '#8B5CF6', shirtColor: '#FFFFFF', 
    pantsColor: '#FFFFFF', name: 'ALEX', hairStyle: 'ponytail', accessory: 'none'
  },
  scientist: { 
    skinTone: '#5C3A21', hairColor: '#F5E6C8', shirtColor: '#FFFFFF', 
    pantsColor: '#37474F', name: 'SAM', hairStyle: 'curly', accessory: 'glasses'
  },
  pilot: { 
    skinTone: '#3D2314', hairColor: '#1a1a1a', shirtColor: '#0D47A1', 
    pantsColor: '#1a1a1a', name: 'PETE', hairStyle: 'wavy', accessory: 'sunglasses'
  },
  firefighter: { 
    skinTone: '#8D5524', hairColor: '#EF4444', shirtColor: '#F44336', 
    pantsColor: '#5D4037', name: 'FIONA', hairStyle: 'ponytail', accessory: 'none'
  },
  vet: { 
    skinTone: '#D4A574', hairColor: '#FF69B4', shirtColor: '#81C784', 
    pantsColor: '#2E7D32', name: 'VIC', hairStyle: 'pigtails', accessory: 'bow'
  },
  postie: { 
    skinTone: '#3D2314', hairColor: '#4169E1', shirtColor: '#F44336', 
    pantsColor: '#1a1a1a', name: 'PAT', hairStyle: 'braids', accessory: 'necklace'
  },
  zookeeper: { 
    skinTone: '#5C3A21', hairColor: '#B87333', shirtColor: '#795548', 
    pantsColor: '#4E342E', name: 'ZARA', hairStyle: 'ponytail', accessory: 'headband'
  },
  magician: { 
    skinTone: '#8D5524', hairColor: '#8B5CF6', shirtColor: '#7B1FA2', 
    pantsColor: '#1a1a1a', name: 'MAX', hairStyle: 'long', accessory: 'wizardhat'
  },
};
